var _ellipse, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 11,
    rx: 11,
    ry: 11,
    transform: "rotate(90 11 11)",
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.817 14.8717C10.5098 15.2886 10.0314 15.5449 9.51418 15.5704C8.99692 15.5961 8.49594 15.3876 8.14936 15.0027L5.04345 11.556C4.54982 11.0085 4.59367 10.1646 5.14112 9.67101C5.6891 9.17738 6.53247 9.2215 7.02609 9.76921L9.22352 12.2079C9.25608 12.2442 9.30334 12.2636 9.35191 12.2612C9.40075 12.2589 9.44539 12.2345 9.47453 12.1956L13.9912 6.06964C14.4284 5.47624 15.2639 5.34994 15.8575 5.78738C16.4507 6.22482 16.5767 7.0603 16.1393 7.65344L10.817 14.8717Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 11.7,
    height: 11.7,
    fill: "white",
    transform: "translate(4.7 4.69995)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDay);
export default __webpack_public_path__ + "static/media/checkDay.28df93ce.svg";
export { ForwardRef as ReactComponent };